<mat-card>
  <mat-card-subtitle>Masse salariale / SBTCP / DRH</mat-card-subtitle>
  <mat-card-content>
    <form [formGroup]="formFormGroup">
      <div>
        <mat-form-field fxFlex="40" fxFlex.lt-md="90">
          <mat-select formControlName="fondement_juridique"
                      placeholder="Fondement juridique"
                      (selectionChange)="onFondementJuridiqueChange()">
            <mat-option *ngFor="let fondement of fondements" [value]="fondement.id">
              {{fondement.label}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field fxFlex="40" fxFlex.lt-md="90">
          <mat-select formControlName="plafond_emploi"
                      placeholder="Plafond d'emploi *">
            <mat-option *ngFor="let plafond of dossierSvc.getPlafondsEmploi()" [value]="plafond.id">
              {{plafond.label}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field fxFlex="30" fxFlex.lt-md="90" appearance="outline">
          <mat-label>Numéro d'emploi</mat-label>
          <input formControlName="numero_emploi"
                 matInput
                 placeholder="Numéro d'emploi">
        </mat-form-field>
      </div>

      <div *ngIf="dossier?.remuneration && dossier.remuneration === remunerationEnum.indiciaire">
        <mat-progress-bar *ngIf="calculateETPTEnCours" class="p8-cm_data-table__progress-bar" mode="indeterminate"></mat-progress-bar>
        <div>
          <mat-list>
            <mat-list-item>
              <mat-icon mat-list-icon>timelapse</mat-icon>
              <h3 mat-line>ETPT</h3>
              <mat-label mat-line *ngFor="let etp of etpt"><strong>{{etp.annee}}&nbsp;&nbsp;</strong> {{etp.etpt | number:'1.3-3'}}</mat-label>
            </mat-list-item>
          </mat-list>
        </div>
        <div>
          <mat-form-field fxFlex="30" fxFlex.lt-md="90" appearance="outline">
            <mat-label>Cumul période ETPT décompte plafond d'emploi</mat-label>
            <input formControlName="decompte"
                   matInput
                   type="number"
                   placeholder="Cumul période ETPT décompte plafond d'emploi">
          </mat-form-field>
        </div>
      </div>

      <div>
        <mat-form-field fxFlex="30" fxFlex.lt-md="90" appearance="outline">
          <mat-label>Coût estimé en € - chiffre entier sans virgule</mat-label>
          <input formControlName="cout_estime"
                 matInput
                 type="number"
                 placeholder="Coût estimé en € - chiffre entier sans virgule">
        </mat-form-field>
      </div>
      <div>
        <mat-form-field fxFlex="30" fxFlex.lt-md="90" appearance="outline">
          <mat-label>INM MS</mat-label>
          <input formControlName="inm"
                 matInput
                 type="number"
                 placeholder="INM">
        </mat-form-field>
      </div>
    </form>
  </mat-card-content>
</mat-card>
